module.exports = __webpack_public_path__ + "assets/img/16_1738.b072bfc7.jpg";